import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CubeGrid } from '../components/ui/CountingCubes';
import { Sparkles, ChevronRight } from 'lucide-react';

const WelcomePage = ({ hasProgress }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    if (hasProgress) {
      navigate('/home');
    } else {
      navigate('/onboarding');
    }
  };

  return (
    <div className="app-container min-h-screen bg-gradient-soft flex flex-col px-6 py-8 safe-area-top safe-area-bottom">
      {/* Top decorative cubes */}
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="absolute top-8 left-6 opacity-60"
      >
        <CubeGrid count={2} size="sm" animate={false} />
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="absolute top-12 right-6 opacity-60"
      >
        <CubeGrid count={3} size="sm" animate={false} />
      </motion.div>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center">
        {/* Logo and title */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
          className="mb-8 text-center"
        >
          <div className="w-24 h-24 mx-auto mb-6 rounded-3xl bg-primary shadow-button flex items-center justify-center">
            <Sparkles className="w-12 h-12 text-primary-foreground" />
          </div>
          
          <h1 className="text-3xl font-display font-bold text-foreground mb-2">
            Семь Ступенек
          </h1>
          <p className="text-xl font-display text-primary font-bold">
            Счёт
          </p>
        </motion.div>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-center text-muted-foreground text-base mb-10 max-w-[280px] leading-relaxed"
        >
          Учимся считать вместе с ребёнком — короткие занятия каждый день
        </motion.p>

        {/* Animated cubes display */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, type: 'spring', stiffness: 150 }}
          className="mb-12"
        >
          <CubeGrid count={5} size="lg" animate={true} />
        </motion.div>
      </div>

      {/* Action buttons */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="space-y-3"
      >
        <Button
          onClick={handleStart}
          className="btn-child-primary w-full flex items-center justify-center gap-2"
        >
          {hasProgress ? 'Продолжить' : 'Начать'}
          <ChevronRight className="w-5 h-5" />
        </Button>

        {hasProgress && (
          <Button
            onClick={() => navigate('/onboarding')}
            variant="ghost"
            className="w-full text-muted-foreground hover:text-foreground"
          >
            Начать заново
          </Button>
        )}
      </motion.div>

      {/* Footer note */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="text-center text-xs text-muted-foreground mt-6"
      >
        Для детей 3-5 лет • Занятие 3-7 мин
      </motion.p>
    </div>
  );
};

export default WelcomePage;
